module.exports = __webpack_public_path__ + "img/card.f6663c68.jpg";